import { ConcreteEncodable } from "./ConcreteEncodable";

import { FwdRollPricingDataUpdateEncoder } from "../../encoder/FwdRollPricingDataUpdateEncoder";

import * as CubiqTS from "../../index";

export class FwdRollPricingDataUpdate extends ConcreteEncodable {
  public static enType: string = "com.bcdfx.model.fwdroll.FwdRollPricingDataUpdate";

  /*FID=1*/
  public rowId: string;
  /*FID=2*/
  public operation: CubiqTS.FwdRollUpdateOperation;
  /*FID=3*/
  public rowType: CubiqTS.FwdRollRowType;
  /*FID=4*/
  public model: CubiqTS.BaseFwdRollData | null = null;
  /*FID=100*/
  public messageId: string;

  constructor() {
    super();
    this.encoder = FwdRollPricingDataUpdateEncoder.Instance;
    this.setEncodableType(FwdRollPricingDataUpdate.enType);
    //Model
  }

  public toString(): string {
    return (
      "FwdRollPricingDataUpdate[" +
      "rowId=" +
      this.rowId +
      "operation=" +
      this.operation +
      "rowType=" +
      this.rowType +
      "model=" +
      this.model +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
